import React from 'react';
import { motion } from 'framer-motion';
export interface SlideProps {
  index: number;
  total: number;
}
interface SlideHeaderProps {
  eyebrow: string;
  children: React.ReactNode;
}
/** Standard interior-slide header: numbered eyebrow + large headline-led title. */
export function SlideHeader({
  eyebrow,
  children
}: SlideHeaderProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.2,
    duration: 0.6
  }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-375" data-mp="3eo2gq9jkgbar">
      <p className="text-[var(--brand)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.4rem,1vw,0.9rem)]" data-id="element-376" data-mp="30ob9qsrgvv69">
        {eyebrow}
      </p>
      <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08] max-w-5xl tracking-tight" data-id="element-377" data-mp="286fcu33qnblf">
        {children}
      </h2>
    </motion.div>;
}
interface SlideBannerProps {
  eyebrow?: string;
  children: React.ReactNode;
  stat?: React.ReactNode;
}
/** Full-bleed brand-color closing banner (rendered edge-to-edge by InteriorSlide). */
export function SlideBanner({
  eyebrow,
  children,
  stat
}: SlideBannerProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.85,
    duration: 0.6
  }} className="bg-[var(--brand)] px-[clamp(2rem,4vw,4rem)] py-[clamp(1.25rem,2vw,2rem)] flex items-center justify-between gap-6 flex-shrink-0" data-id="element-378" data-mp="1r7stqmwr4dt1">
      <div className="min-w-0" data-id="element-379" data-mp="18egmt8ji0tmp">
        {eyebrow && <p className="text-[var(--brand-lighter)] text-[clamp(0.75rem,1vw,1rem)] font-semibold uppercase tracking-wider mb-1" data-id="element-380" data-mp="1de1ldhurazyw">
            {eyebrow}
          </p>}
        <p className="text-white font-bold text-[clamp(1.1rem,2vw,1.85rem)] leading-tight" data-id="element-381" data-mp="2jwhng0vh9gur">
          {children}
        </p>
      </div>
      {stat && <div className="flex-shrink-0" data-id="element-382" data-mp="1z4jhr78uvw47">{stat}</div>}
    </motion.div>;
}
interface InteriorSlideProps {
  surface?: boolean;
  banner?: React.ReactNode;
  children: React.ReactNode;
}
/**
 * Full-screen interior slide. Content sits in a padded column engineered to FIT
 * one screen (no scroll). An optional banner renders full-bleed at the bottom edge.
 */
export function InteriorSlide({
  surface = false,
  banner,
  children
}: InteriorSlideProps) {
  return <div className={`relative w-full h-full overflow-hidden ${surface ? 'bg-[var(--surface)]' : 'bg-[var(--bg)]'} flex flex-col`} data-id="element-383" data-mp="1gci95d6a4rhl">
      <div className="flex-1 min-h-0 p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-384" data-mp="1q4whwpvryyd9">
        {children}
      </div>
      {banner}
    </div>;
}